/** Exact T1 copy from MKT-SALES-GROWIT-T1-COPY-AUD-NOTES-DISPOSITION-20260929.0702.md.
 * Demo destination: SEC-AWS-GROWIT-R12-AWS-HOSTED-RELEASE-WITNESS-20261001.0033.md (MD5 a1b874c39baa431b9808fd667eb7ac0f). */
export const GROWIT_DEMO_URL = 'https://d1je1mh4j07euy.cloudfront.net/';

export const growitCopy = {
  heading: 'Grow It: your farm sets the direction',
  metaTitle: 'Grow It — Up in Farms',
  metaDescription: "Grow It invites family farms to explore Farm2Cloud's proposed planning tools through a simulated farm walkthrough.",
  paragraphs: [
    'You know what matters on your farm. Grow It invites family farms to explore tools designed to start with your values, goals, and resources, then help shape a production plan around the way you work.',
    'See the Grow It vision in a guided walkthrough: practical planning, scientifically grounded guidance, and a clearer connection between daily work, food safety, conservation, and market readiness. The goal is precision farming at a personal scale.',
    'The walkthrough uses a simulated farm to show proposed capabilities. Explore the steps at your pace and consider which parts would help your operation.',
  ],
  reserveLabel: 'Reserve your seat — opening soon',
  demoLinkLabel: 'Explore the Grow It walkthrough',
  demoFallback: 'Demo link shared at the session',
} as const;
